/*
 * Conteúdo do painel institucional das telas de acesso (login/cadastro/recuperação e redefinição).
 * TEXTOS PROVISÓRIOS — baseados nas funcionalidades reais do sistema; substitua aqui
 * quando os textos definitivos chegarem.
 *
 * A marca respeita o branding do órgão: com logo próprio (logo_url), usa o logo e os textos
 * configurados; sem logo, usa o símbolo Scorvia com o título configurado como descritor.
 */
import { BarChart3, GitBranch, History, Inbox } from "lucide-react";
import { scorviaBrand, type LoginBrand, type LoginLayoutProps } from "@scorvia/design-system/login";
import "@scorvia/design-system/login.css";
import type { Branding } from "@/features/branding/types";

export function marcaDoBranding(branding: Pick<Branding, "logo_url" | "titulo" | "subtitulo" | "orgao_nome">): LoginBrand {
  if (branding.logo_url) {
    return {
      symbol: <img src={branding.logo_url} alt="" />,
      name: branding.orgao_nome || branding.titulo,
      descriptor: branding.orgao_nome ? branding.titulo : branding.subtitulo,
    };
  }
  return scorviaBrand(branding.titulo);
}

export const PAINEL_LOGIN: Pick<
  LoginLayoutProps,
  "badge" | "title" | "highlight" | "lead" | "steps" | "panelLabel" | "footer"
> = {
  badge: "Gestão de processos administrativos",
  title: "Cada processo no fluxo certo, do início ao fim.",
  highlight: "fluxo certo",
  lead: "Modele etapas, acompanhe prazos e mantenha a trilha de cada movimentação em um só lugar.",
  steps: [
    {
      icon: <GitBranch />,
      title: "Fluxos em BPMN",
      description: "Etapas e responsáveis definidos para cada tipo de processo",
    },
    {
      icon: <Inbox />,
      title: "Tarefas e prazos",
      description: "Caixa de tarefas por setor e painel de SLA",
    },
    {
      icon: <History />,
      title: "Rastreabilidade",
      description: "Histórico de movimentações e trilha de auditoria",
    },
    {
      icon: <BarChart3 />,
      title: "Relatórios",
      description: "Indicadores e relatórios por órgão, setor e período",
    },
  ],
  panelLabel: "Sobre o sistema",
  footer: `© ${new Date().getFullYear()} Scorvia Tech · Gestão de processos`,
};
